module.exports = __webpack_public_path__ + "img/D201602_2.3a469015.jpg";